import { Spin } from 'antd'
import React, { Suspense } from 'react'

const loadingLayoutStyle = {
  width: '100%',
  height: '100%',
  display: 'flex',
}

export const LoadingLayout: React.FC = () => {
  return (
    <div style={loadingLayoutStyle}>
      <Spin
        size="large"
        style={{ margin: 'auto' }}
        delay={100} />
    </div>
  )
}

const withSuspensePage = <OriginalProps extends {[key: string]: any}>(PageToWrap: React.FunctionComponent<OriginalProps>) => {
  const wrapper = (props: OriginalProps) => {
    return (
      <Suspense fallback={<LoadingLayout />}>
        <PageToWrap {...props} />
      </Suspense>
    )
  }

  wrapper.displayName = `withSuspensePage`
  return wrapper
}

export default withSuspensePage
